export const TYPES = {
  ContactsUseCases: Symbol.for('ContactsUseCases'),
  ContactsStateRepository: Symbol.for('ContactsStateRepository'),
  ContactsDao: Symbol.for('ContactsDao'),
};
